import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExploreIconInactive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.25515 11.6387C9.5308 11.0323 9.6686 10.7291 9.8627 10.4694C10.0348 10.2392 10.2392 10.0348 10.4694 9.8627C10.7291 9.6686 11.0323 9.5308 11.6387 9.25515L15.5 7.5L13.7448 11.3613C13.4692 11.9677 13.3314 12.2709 13.1373 12.5306C12.9652 12.7608 12.7608 12.9652 12.5306 13.1373C12.2709 13.3314 11.9677 13.4692 11.3613 13.7448L7.5 15.5L9.25515 11.6387Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.5 11.5C21.5 17.0228 17.0228 21.5 11.5 21.5C5.97715 21.5 1.5 17.0228 1.5 11.5C1.5 5.97715 5.97715 1.5 11.5 1.5C17.0228 1.5 21.5 5.97715 21.5 11.5Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgExploreIconInactive;
